import { Component, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MdSnackBar } from '@angular/material';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';

import { StorageService } from '../services/storage.service';

import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';

@Component({
  selector: 'gaschoice',
  providers: [StorageService],
  templateUrl: './gaschoice.component.html',
  styleUrls: ['./gaschoice.component.scss']
})
export class GaschoiceComponent {

  storages: any[] = [];
  filteredStorages: any[];
  filterTitle: string;
  filterString: string = '';

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _storageService: StorageService,
    private _router: Router,
    private _dialogService: TdDialogService,
    private _snackBarService: MdSnackBar,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService) {
  }

 

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/gas/gaschoice.component.ts